import { MentoriaService } from './../../../services/mentoria.service';
import { HelpersService } from 'src/app/services/helpers.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-resposta',
  templateUrl: './resposta.component.html',
  styleUrls: ['./resposta.component.css']
})
export class RespostaComponent implements OnInit {
  questao$: Observable<any>;
  questaoSource$: Observable<any>;
  newMsg: string;
  showSpinner = true;

  constructor(private route: ActivatedRoute,
              public helper: HelpersService,
              private mentoria: MentoriaService) { }

  ngOnInit(): void {
    // Captura o parametro recebido do outro component
    const questaoID = this.route.snapshot.paramMap.get('questaoId');
    this.questaoSource$ = this.mentoria.getQuestao(questaoID);
    const source = this.mentoria.getResposta(questaoID);
    this.questao$ = this.mentoria.joinUsers(source);
  }

  ngAfterContentInit() {
    this.showSpinner = false;
  }

  submit(chatId) {
    if (!this.newMsg || this.newMsg === '') {
      this.helper.openSnackBar('Digite algo na mensagem!!!', 'OK');
    } else {
      this.mentoria.sendMessage(chatId, this.newMsg);
      this.newMsg = '';
    }
  }

  trackByCreated(i, msg) {
    const date: Date = msg.createdAt;
    return date;
  }

}
